
import { GlError } from "./context";

export function createBuffer(gl: WebGL2RenderingContext, label: string): WebGLBuffer {
  const buffer = gl.createBuffer();
  if (buffer === null) throw new GlError(`could not create the ${label} buffer`);
  return buffer;
}

export function createVertexArray(gl: WebGL2RenderingContext, label: string): WebGLVertexArrayObject {
  const vao = gl.createVertexArray();
  if (vao === null) throw new GlError(`could not create the ${label} vertex array`);
  return vao;
}

export interface AttributeSpec {
  /** Attribute name, resolved against the linked program. */
  readonly name: string;
  readonly components: 1 | 2 | 3 | 4;
  /** A `gl.*` scalar type. Integer types arrive in the shader as floats unless
   *  `normalized` says otherwise -- there is no integer attribute here because
   *  every value ends up in float arithmetic anyway. */
  readonly type: number;
  /** Divide by 255 (or 65535) on the way in. Used for the 0-or-255 flag bytes,
   *  which the shader wants as 0..1 so it can blend them. */
  readonly normalized: boolean;
  readonly offset: number;
  /** 0 for per-vertex, 1 for per-instance. */
  readonly divisor: 0 | 1;
}

export function describeAttributes(
  gl: WebGL2RenderingContext,
  program: WebGLProgram,
  stride: number,
  specs: readonly AttributeSpec[],
): void {
  for (const spec of specs) {
    const location = gl.getAttribLocation(program, spec.name);
    if (location < 0) continue;
    gl.enableVertexAttribArray(location);
    gl.vertexAttribPointer(location, spec.components, spec.type, spec.normalized, stride, spec.offset);
    gl.vertexAttribDivisor(location, spec.divisor);
  }
}
